"use client";

import { AcknowledgmentModal } from "@/components/AcknowledgmentModal";

interface AcknowledgmentClientWrapperProps {
  isOpen: boolean;
  userName: string;
}

const AcknowledgmentClientWrapper = ({ 
  isOpen, 
  userName 
}: AcknowledgmentClientWrapperProps) => {
  return <AcknowledgmentModal isOpen={isOpen} userName={userName} />;
};

export default AcknowledgmentClientWrapper;